module.exports = __webpack_public_path__ + "media/images/countrysquared/se-18eaeabee4a0de634434c37c5dbf60b2.svg";